import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";

const HeroSection = () => {
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "60vh", sm: "70vh", md: "80vh" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #000814 0%, #001d3d 50%, #003566 100%)",
        overflow: "hidden",
        px: { xs: 2, sm: 4 },
      }}
    >
      <motion.div
        style={{
          position: "absolute",
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",
          background: "radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%)",
        }}
        animate={{ rotate: 360 }}
        transition={{ duration: 120, repeat: Infinity, ease: "linear" }}
      />

      <Box sx={{ maxWidth: "1200px", textAlign: "center", zIndex: 1, px: { xs: 2, md: 0 } }}>
        <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 800,
              mb: 3,
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem", lg: "4rem" },
              background: "linear-gradient(45deg, #fff 0%, #90caf9 50%, #42a5f5 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Redefining Roommate Experiences
          </Typography>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}>
          <Typography
            variant="h5"
            component="p"
            sx={{
              maxWidth: "800px",
              mx: "auto",
              mb: 4,
              color: "rgba(255,255,255,0.8)",
              fontSize: { xs: "1rem", md: "1.25rem" },
            }}
          >
            We're revolutionizing how people find roommates by focusing on compatibility,
            shared values, and creating meaningful living experiences.
          </Typography>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => smoothScrollTo("team-section", 2000)}
            sx={{
              backgroundColor: "#fff",
              color: "#001d3d",
              "&:hover": { backgroundColor: "#e0e0e0" },
              px: { xs: 4, md: 6 },
              py: 1.5,
              fontSize: { xs: "0.875rem", md: "1rem" },
              fontWeight: 600,
              borderRadius: "4px",
            }}
          >
            Meet the Team
          </Button>
        </motion.div>
      </Box>
    </Box>
  );
};

export default HeroSection;

const smoothScrollTo = (targetId, duration = 1000) => {
  const target = document.getElementById(targetId);
  if (!target) return;

  const start = window.pageYOffset;
  const end = target.getBoundingClientRect().top + window.pageYOffset;
  const distance = end - start;
  let startTime = null;

  const easeInOutQuad = (t) => {
    return t < 0.5
      ? 2 * t * t
      : -1 + (4 - 2 * t) * t;
  };

  const animation = (currentTime) => {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const ease = easeInOutQuad(progress);

    window.scrollTo(0, start + distance * ease);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  };

  requestAnimationFrame(animation);
};
